export const errorConstants = {
  SET_ERROR: 'error/SET_ERROR',
  FLUSH: 'error/flush',
};
